
const SEX_OPTION = {
  1: '男',
  2: '女',
};

export default {
  SEX_OPTION,
};
